/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Save_LinkInputs */

const en_services_svc_save_link = /** @type {(inputs: Services_Svc_Save_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore customer questions`)
};

const lv_services_svc_save_link = /** @type {(inputs: Services_Svc_Save_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apskatīt klientu jautājumus`)
};

/**
* | output |
* | --- |
* | "Explore customer questions" |
*
* @param {Services_Svc_Save_LinkInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_save_link = /** @type {((inputs?: Services_Svc_Save_LinkInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Save_LinkInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_save_link(inputs)
	return en_services_svc_save_link(inputs)
});